import styled from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

export const Error = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${colors.red};

  @media ${device.isTablet} {
    padding-top: 34px;
    padding-bottom: 40px;
    padding-right: 1rem;
  }

  @media ${device.isMobile} {
    padding-bottom: 6px;
    flex-wrap: wrap;
    padding-right: 1rem;
  }
`;

export type ComponentProps = ReturnType<typeof Error>;

export default Error;
